import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { DashboardUserSummaryResponse } from "types/dashboard-user-summary";

interface GetAllUserSummary extends AxiosResponse {
    data: DashboardUserSummaryResponse
}

const useUserSummary = () => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();


    return useQuery<unknown, unknown, GetAllUserSummary>({
        queryKey: ['get-all-user-summary'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/user/summary`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useUserSummary;